import type { MultiLocationSuggestOption } from '@construct-kit/core';
import type { BoundingBoxType } from './model/constants/filterTypes';

const MAP_AREA_TEXT = 'Map area';

export const buildLocationSearchBtnLabel = (
  searchLocations?: Array<MultiLocationSuggestOption>,
  boundingBox?: BoundingBoxType,
): string | undefined => {
  if (boundingBox) {
    return MAP_AREA_TEXT;
  }

  if (!searchLocations || searchLocations.length === 0) {
    return '';
  }

  if (searchLocations.length === 1) {
    return searchLocations[0].display.text;
  }

  return `${searchLocations[0].display.text} + ${searchLocations.length - 1}`;
};
